import { Ac2AccessDeviceModel } from "src/api/access/productac-types";
import { DeviceControlType, DeviceStatus, DeviceType, ExecuteResultType } from "./monitoring-types";

export const isPassExecute = (item: DeviceControlType) => {
  //재실 실행
  const isSensorExecute = item.labelType === DeviceType.SENSOR && item.labels?.some((label) => label.name === "용도" && label.value === "동작감지");
  //실내기 실행
  let isIndoorUnitExecute = false;

  if (item.labelType === DeviceType.INDOOR_UNIT) {
    if (item.platform === "ST") {
      isIndoorUnitExecute =
        item.labels?.some((label) => label.name === "용도" && label.value === "전원") || // 활성화 // 상태
        item.labels?.some((label) => label.name === "용도" && label.value === "공조/모드") || // 모드
        item.labels?.some((label) => label.name === "용도" && label.value === "공조/희망온도") || // 희망온도
        item.labels?.some((label) => label.name === "용도" && label.value === "측정온도") || // 측정온도
        false;
    } else {
      isIndoorUnitExecute =
        item.labels?.some((label) => label.name === "용도" && label.value === "공조/상태") ||
        item.labels?.some((label) => label.name === "용도" && label.value === "공조") ||
        item.labels?.some((label) => label.name === "용도" && label.value === "습도") || // 모드
        item.labels?.some((label) => label.name === "용도" && label.value === "측정온도") || // 측정온도
        item.labels?.some((label) => label.name === "용도" && label.value === "공조/환기") || // 측정온도
        item.labels?.some((label) => label.name === "용도" && label.value === "공조/희망온도") || // 측정온도
        item.labels?.some((label) => label.name === "용도" && label.value === "CO2") || // 측정온도
        false;
    }
  }
  //  온도
  let isTemperatureExecute = false;
  if (item.labelType === DeviceType.TEMPERATURE) {
    if (item.platform === "ST") {
      isTemperatureExecute = item.labels?.some((label) => label.name === "용도" && label.value === "측정온도") || false;
    } else {
      isTemperatureExecute = item.labels?.some((label) => label.name === "용도" && label.value === "공조/상태") || false;
    }
  }

  // 조명
  if (item.labelType === DeviceType.LIGHT) {
  }
  const isLightExecute =
    (item.labelType === DeviceType.LIGHT && item.labels?.some((label) => label.name === "용도" && label.value === "전원")) ||
    item.labels?.some((label) => label.name === "용도" && label.value === "전원/레벨") ||
    item.labels?.some((label) => label.name === "용도" && label.value === "조명/상태");

  //화장실
  const isToiltetExecute =
    ((item.labelType === DeviceType.MENS_TOILET || item.labelType === DeviceType.WOMEN_TOILET) &&
      item.labels?.some((label) => label.name === "용도" && label.value === "접촉감지")) ||
    item.labels?.some((label) => label.name === "용도" && label.value === "동작감지") ||
    item.labels?.some((label) => label.name === "용도" && label.value === "재실감지");

  return isSensorExecute || isIndoorUnitExecute || isTemperatureExecute || isLightExecute || isToiltetExecute;
};

// 기기 상태 확인
const getDeviceStatus = (value: string | undefined) => {
  if (!value) return DeviceStatus.CANNOT; // 알수없음 (불가)

  switch (value) {
    // 활성화
    case "on": // 실내기 / 조명
    case "On": // 실내기 B-iot / 조명 B-iot
    case "active": // 재실 / 조명
    case "closed": // 화장실
    case "ONLINE": // 출입기기
    case "present": // 화장실 / 재실 (아이아이텀바인)
      return DeviceStatus.ACTIVE;

    // 비활성화
    case "off": // 실내기 / 조명
    case "Off": // 실내기 B-iot / 조명 B-iot
    case "inactive": // 재실 / 조명
    case "open": // 화장실
    case "OFFLINE": // 출입기기
    case "not present": // 화장실 / 재실 (아이아이텀바인)
      return DeviceStatus.INACTIVE; // 비활성화

    default:
      return DeviceStatus.CANNOT; // 알수없음 (불가)
  }
};

// 기기의 timestamp가 현재 시간으로부터 6시간 초과면 old 한 데이터 - 노란색 아이콘으로 표시
export const isCaution = (timestamp: string) => {
  if (!timestamp) return;
  const sixHourMilisecond = 6 * 60 * 60 * 1000;
  // 현재 시간
  const now = new Date();

  // 타임스탬프를 Date 객체로 변환
  const dateToCompare = new Date(timestamp);

  // 6시간 이전인지 확인
  const isMoreThanSixHours = now.getTime() - dateToCompare.getTime() > sixHourMilisecond;
  return isMoreThanSixHours;
};

// 각 기기들의 동작 상태 확인
export const deviceStatusCheck = (type: "IOT" | "ACCESS" | "CCTV", device: any) => {
  const iotDevice: ExecuteResultType = type === "IOT" && device;
  const accessDevice: Ac2AccessDeviceModel = type === "ACCESS" && device;

  // if (!device) return DeviceStatus.CANNOT;
  // 출입기기 상태 확인
  if (type === "ACCESS") {
    return getDeviceStatus(accessDevice.deviceStatusInfo?.deviceStatus);
  }

  // iot 기기 상태 확인
  else {
    // result 값이 없거나 error 데이터가 있으면 "불가 표시"
    if (!iotDevice.result || iotDevice.result.error) return DeviceStatus.CANNOT;

    if (iotDevice.labelType === DeviceType.SENSOR && !iotDevice.result) {
      console.log("iotDevice", iotDevice);
    }

    // 재실
    if (iotDevice.labelType === DeviceType.SENSOR) {
      if (iotDevice.result.motion) {
        if (isCaution(iotDevice.result.motion.timestamp)) {
          return DeviceStatus.CAUTION;
        }
        return getDeviceStatus(iotDevice.result.motion.value);
      }
    }
    // iotDevice.labelType === DeviceType.INDOOR_UNIT && console.log("iotDevice", iotDevice);

    // 실내기
    if (iotDevice.labelType === DeviceType.INDOOR_UNIT && iotDevice.platform === "ST") {
      if (iotDevice.result.switch) {
        if (isCaution(iotDevice.result.switch.timestamp)) {
          return DeviceStatus.CAUTION;
        }
        return getDeviceStatus(iotDevice.result.switch.value);
      } else {
        return DeviceStatus.CANNOT;
      }
    }

    // IotDeviceCompe 때 작업
    //실내기 B-iot 일 때
    if (iotDevice.labelType === DeviceType.INDOOR_UNIT && iotDevice.platform === "B_IOT") {
      if (iotDevice.result.operation) {
        if (isCaution(iotDevice.result.operation.timestamp)) {
          return DeviceStatus.CAUTION;
        }
        return getDeviceStatus(iotDevice.result.operation.power);
      }
      //CES 대비 > FTU 일 때
      if (iotDevice.result && iotDevice.result.controlPoint) {
        //공조/환기 기기로 active inactive 표시

        return iotDevice.labels?.some((lable) => lable.value === "FTU") ? DeviceStatus.ACTIVE : DeviceStatus.INACTIVE;
      }

      return DeviceStatus.CANNOT;
    }

    //실내기 B-iot 일 때  > SpaceMonitoring 의 원본
    // if (iotDevice.labelType === DeviceType.INDOOR_UNIT && iotDevice.platform === "B_IOT") {
    //   if (iotDevice.result.operation) {
    //     if (isCaution(iotDevice.result.operation.timestamp)) {
    //       return DeviceStatus.CAUTION;
    //     }
    //     return getDeviceStatus(iotDevice.result.operation.power);
    //   }
    //   //CES 대비 > FTU 일 때
    //   if (Array.isArray(iotDevice.result) && iotDevice.result.find((item: any) => item.controlPoint)) {
    //     //공조/환기 기기로 active inactive 표시

    //     return iotDevice.labels?.some((lable) => lable.value === "FTU") ? DeviceStatus.ACTIVE : DeviceStatus.INACTIVE;
    //   }

    //   return DeviceStatus.CANNOT;
    // }

    // 조명 B_IOT
    if (iotDevice.labelType === DeviceType.LIGHT && iotDevice.platform === "B_IOT") {
      if (iotDevice.result.operation) {
        return getDeviceStatus(iotDevice.result.operation.power);
      } else {
        return DeviceStatus.CANNOT;
      }
    }

    // 조명 스위치
    if (iotDevice.labelType === DeviceType.LIGHT && iotDevice.result.switch) {
      if (isCaution(iotDevice.result.switch.timestamp)) {
        return DeviceStatus.CAUTION;
      }
      return getDeviceStatus(iotDevice.result.switch.value);
    }

    //남자 화장실
    if (iotDevice.labelType === DeviceType.MENS_TOILET && iotDevice.result) {
      if (iotDevice.result.contact) {
        if (isCaution(iotDevice.result.contact.timestamp)) {
          return DeviceStatus.CAUTION;
        }
        // INCATIVE > "open" / ACTIVE > "closed" (이용중) 상태

        return getDeviceStatus(iotDevice.result.contact.value);
      }

      if (iotDevice.result.motion) {
        if (isCaution(iotDevice.result.motion.timestamp)) {
          return DeviceStatus.CAUTION;
        }
        return getDeviceStatus(iotDevice.result.motion.value);
      }

      if (iotDevice.result.presence) {
        if (isCaution(iotDevice.result.presence.timestamp)) {
          return DeviceStatus.CAUTION;
        }
        return getDeviceStatus(iotDevice.result.presence.value);
      }
    }

    // 여자 화장실
    if (iotDevice.labelType === DeviceType.WOMEN_TOILET && iotDevice.result) {
      if (iotDevice.result.contact) {
        if (isCaution(iotDevice.result.contact.timestamp)) {
          return DeviceStatus.CAUTION;
        }
        return getDeviceStatus(iotDevice.result.contact.value);
      }

      if (iotDevice.result.motion) {
        if (isCaution(iotDevice.result.motion.timestamp)) {
          return DeviceStatus.CAUTION;
        }
        return getDeviceStatus(iotDevice.result.motion.value);
      }

      if (iotDevice.result.presence) {
        if (isCaution(iotDevice.result.presence.timestamp)) {
          return DeviceStatus.CAUTION;
        }
        return getDeviceStatus(iotDevice.result.presence.value);
      }
    }
  }
};
